import { Alert, Box, Typography, useTheme } from '@mui/material';
import appConfig from '../../config/appConfig';

const FeatureNotSupportedDialog = ({ title, description }) => {
  const theme = useTheme();
  const defaultTitle = 'Feature Not Supported';
  const defaultDescription = 'This feature is not included in your subscription.';
  const defaultReachOut = 'Please reach out to';
  const defaultContact = 'to get access.';

  const dialogTitle = title || defaultTitle;
  const dialogDescription = description || defaultDescription;
  const linkColor = theme.palette.primary.main;

  return (
    <Box
      sx={{
        display: 'flex',
        width: '50%',
        flexDirection: 'column',
        justifyContent: 'center',
        textAlign: 'left',
        padding: theme.spacing(4),
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: '8px',
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[2],
        margin: 'auto',
      }}
    >
      <Typography variant="h5" component="h2" gutterBottom>
        {dialogTitle}
      </Typography>
      <Typography variant="subtitle1" gutterBottom>
        {dialogDescription}
      </Typography>
      <Typography variant="subtitle2" color="textSecondary" borderLeft={`5px solid #FFA726`}>
        <Alert icon={false} severity="warning">
          {defaultDescription} {defaultReachOut}{' '}
          <a href={`mailto:${appConfig.brandEmail}`} style={{ color: linkColor }}>
            {`${appConfig.brandEmail}`}
          </a>{' '}
          {defaultContact}
        </Alert>
      </Typography>
    </Box>
  );
};

export default FeatureNotSupportedDialog;
